import {IActionModel} from "../../shared/models/action.model";
import {
    GET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION,
    GET_CLIENT_BASIC_DETAILS,
    GET_CLIENT_CASE_DETAILS,
    GET_CLIENT_COMMUNICATION_REFERRAL_DETAILS,
    GET_CLIENT_MEDICAL_HISTORY_DETAILS,
    SET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION,
    SET_CLIENT_BASIC_DETAILS_FAILED,
    SET_CLIENT_BASIC_DETAILS_SUCCESS,
    SET_CLIENT_CASE_DETAILS,
    SET_CLIENT_COMMUNICATION_REFERRAL_DETAILS_FAILED,
    SET_CLIENT_COMMUNICATION_REFERRAL_DETAILS_SUCCESS,
    SET_CLIENT_MEDICAL_HISTORY_DETAILS_FAILED,
    SET_CLIENT_MEDICAL_HISTORY_DETAILS_SUCCESS,
    GET_CLIENT_INJURY_DETAILS,
    SET_CLIENT_INJURY_DETAILS,
    GET_CLIENT_SIGNATURE_DETAILS,
    SET_CLIENT_SIGNATURE_DETAILS,
    GET_SERVICE_LIST,
    SET_SERVICE_LIST,
    GET_AUTHORIZATION_DISCLOSE_PROTECTED_HEALTH_INFORMATION,
    SET_AUTHORIZATION_DISCLOSE_PROTECTED_HEALTH_INFORMATION
} from "../actions/client.action";

export interface IClientReducerState {
    isClientBasicDetailsLoaded?: boolean;
    isClientBasicDetailsLoading?: boolean;
    isClientBasicDetailsLoadingFailed?: boolean;
    clientBasicDetails?: any;
    clientBasicDetailsError?: any;
    isClientCommunicationReferralDetailsLoaded?: boolean;
    isClientCommunicationReferralDetailsLoading?: boolean;
    isClientCommunicationReferralDetailsLoadingFailed?: boolean;
    clientCommunicationReferralDetails?: any;
    clientCommunicationReferralDetailsError?: any;
    isClientMedicalHistoryDetailsLoaded?: boolean;
    isClientMedicalHistoryDetailsLoading?: boolean;
    isClientMedicalHistoryDetailsLoadingFailed?: boolean;
    clientMedicalHistoryDetails?: any;
    clientMedicalHistoryDetailsError?: any;
    isClientCaseDetailsLoading?: boolean;
    isClientCaseDetailsLoaded?: boolean;
    isClientCaseDetailsLoadingFailed?: boolean;
    clientCaseDetails?: any;
    isClientAuthorizationToReleaseInformationLoading?: boolean;
    isClientAuthorizationToReleaseInformationLoaded?: boolean;
    isClientAuthorizationToReleaseInformationLoadingFailed?: boolean;
    clientAuthorizationToReleaseInformation?: any;
    clientInjuryDetails?: any;
    isClientSignatureDetailsLoading?: boolean;
    isClientSignatureDetailsLoaded?: boolean;
    isClientSignatureDetailsLoadingFailed?: boolean;
    clientSignatureDetails?: any;
    isServiceListLoading?: boolean;
    isServiceListLoaded?: boolean;
    isServiceListLoadingFailed?: boolean;
    serviceList?: any;
    authorizationDiscloseProtectedHealthInformation?: any;
    isAuthorizationDiscloseProtectedHealthInformationLoading?: boolean;
    isAuthorizationDiscloseProtectedHealthInformationLoaded?: boolean
}

const INITIAL_STATE: IClientReducerState = {
    clientBasicDetails: undefined,
    clientCommunicationReferralDetails: undefined,
    clientCaseDetails: undefined,
    clientAuthorizationToReleaseInformation: undefined,
    clientInjuryDetails: undefined,
    clientSignatureDetails: undefined,
    authorizationDiscloseProtectedHealthInformation: undefined
};

const clientReducer = (state: IClientReducerState = INITIAL_STATE, action: IActionModel): IClientReducerState => {
    switch (action.type) {
        case GET_CLIENT_BASIC_DETAILS:
            return {
                ...state,
                isClientBasicDetailsLoaded: false,
                isClientBasicDetailsLoading: true,
                isClientBasicDetailsLoadingFailed: false
            };
        case SET_CLIENT_BASIC_DETAILS_SUCCESS:
            return {
                ...state,
                isClientBasicDetailsLoaded: true,
                isClientBasicDetailsLoading: false,
                isClientBasicDetailsLoadingFailed: false,
                clientBasicDetailsError: undefined,
                clientBasicDetails: action.payload
            }
        case SET_CLIENT_BASIC_DETAILS_FAILED:
            return {
                ...state,
                isClientBasicDetailsLoaded: false,
                isClientBasicDetailsLoading: false,
                isClientBasicDetailsLoadingFailed: true,
                clientBasicDetailsError: action.payload
            }
        case GET_AUTHORIZATION_DISCLOSE_PROTECTED_HEALTH_INFORMATION:
            return {
                ...state,
                isAuthorizationDiscloseProtectedHealthInformationLoading: true,
                isAuthorizationDiscloseProtectedHealthInformationLoaded: false,
            }
        case SET_AUTHORIZATION_DISCLOSE_PROTECTED_HEALTH_INFORMATION:
            return {
                ...state,
                isAuthorizationDiscloseProtectedHealthInformationLoading: false,
                isAuthorizationDiscloseProtectedHealthInformationLoaded: true,
                authorizationDiscloseProtectedHealthInformation: action.payload.authorizationDiscloseProtectedHealthInformation
            }
        case GET_CLIENT_COMMUNICATION_REFERRAL_DETAILS:
            return {
                ...state,
                isClientCommunicationReferralDetailsLoaded: false,
                isClientCommunicationReferralDetailsLoading: true,
                isClientCommunicationReferralDetailsLoadingFailed: false
            };
        case SET_CLIENT_COMMUNICATION_REFERRAL_DETAILS_SUCCESS:
            return {
                ...state,
                isClientCommunicationReferralDetailsLoaded: true,
                isClientCommunicationReferralDetailsLoading: false,
                isClientCommunicationReferralDetailsLoadingFailed: false,
                clientCommunicationReferralDetailsError: undefined,
                clientCommunicationReferralDetails: action.payload
            }
        case SET_CLIENT_COMMUNICATION_REFERRAL_DETAILS_FAILED:
            return {
                ...state,
                isClientCommunicationReferralDetailsLoaded: false,
                isClientCommunicationReferralDetailsLoading: false,
                isClientCommunicationReferralDetailsLoadingFailed: true,
                clientCommunicationReferralDetailsError: action.payload
            }
        case GET_CLIENT_MEDICAL_HISTORY_DETAILS:
            return {
                ...state,
                isClientMedicalHistoryDetailsLoaded: false,
                isClientMedicalHistoryDetailsLoading: true,
                isClientMedicalHistoryDetailsLoadingFailed: false
            };
        case SET_CLIENT_MEDICAL_HISTORY_DETAILS_SUCCESS:
            return {
                ...state,
                isClientMedicalHistoryDetailsLoaded: true,
                isClientMedicalHistoryDetailsLoading: false,
                isClientMedicalHistoryDetailsLoadingFailed: false,
                clientMedicalHistoryDetailsError: undefined,
                clientMedicalHistoryDetails: action.payload
            }
        case SET_CLIENT_MEDICAL_HISTORY_DETAILS_FAILED:
            return {
                ...state,
                isClientMedicalHistoryDetailsLoaded: false,
                isClientMedicalHistoryDetailsLoading: false,
                isClientMedicalHistoryDetailsLoadingFailed: true,
                clientMedicalHistoryDetailsError: action.payload
            }
        case GET_CLIENT_CASE_DETAILS:
            return {
                ...state,
                isClientCaseDetailsLoading: true,
                isClientBasicDetailsLoaded: false,
                isClientBasicDetailsLoadingFailed: false,
            }
        case SET_CLIENT_CASE_DETAILS:
            return {
                ...state,
                clientCaseDetails: action.payload.clientCaseDetails
            }
        case GET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION:
            return {
                ...state,
                isClientAuthorizationToReleaseInformationLoading: true,
                isClientAuthorizationToReleaseInformationLoaded: false,
                isClientAuthorizationToReleaseInformationLoadingFailed: false,
            }
        case SET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION:
            return {
                ...state,
                isClientAuthorizationToReleaseInformationLoading: false,
                isClientAuthorizationToReleaseInformationLoaded: true,
                isClientAuthorizationToReleaseInformationLoadingFailed: false,
                clientAuthorizationToReleaseInformation: action.payload.clientAuthorizationToReleaseInformation
            }
        case GET_CLIENT_INJURY_DETAILS:
            return {
                ...state,
                clientInjuryDetails: action.payload
            }
        case SET_CLIENT_INJURY_DETAILS:
            return {
                ...state,
                clientInjuryDetails: action.payload.clientInjuryDetails
            }
        case GET_CLIENT_SIGNATURE_DETAILS:
            return {
                ...state,
                isClientSignatureDetailsLoading: true,
                isClientSignatureDetailsLoaded: false,
                isClientSignatureDetailsLoadingFailed: false,
            }
        case SET_CLIENT_SIGNATURE_DETAILS:
            return {
                ...state,
                isClientSignatureDetailsLoading: false,
                isClientSignatureDetailsLoaded: true,
                isClientSignatureDetailsLoadingFailed: false,
                clientSignatureDetails: action.payload.clientSignatureDetails
            }
        case GET_SERVICE_LIST:
            return {
                ...state,
                isServiceListLoading: true,
                isServiceListLoadingFailed: false,
                isServiceListLoaded: false,
            }
        case SET_SERVICE_LIST:
            return {
                ...state,
                isServiceListLoading: false,
                isServiceListLoadingFailed: false,
                isServiceListLoaded: true,
                serviceList: action.payload.serviceList
            }

        default:
            return state;
    }
};

export default clientReducer;

